import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {ADMIN_CONSOLE_PAGE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import Whitelist from 'go/components/modules/admin/Whitelist';
import Workflow from 'go/components/modules/admin/Workflow';
import Prescore from 'go/components/modules/admin/Prescore';
import {canViewAdminConsoleTab} from 'go/security/permissions';

export class AdminConsole extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    document.title = ADMIN_CONSOLE_PAGE;
  }

  performAdminAction(configType) {
    switch (configType) {
      case 'whitelist':
        return <Whitelist />;
      case 'workflow':
        return <Workflow />;
      case 'prescore':
        return <Prescore />;
      default:
    }
  }

  render() {
    let configType = _.get(this.props, 'match.params.configType');
    return (
      <React.Fragment>
        {canViewAdminConsoleTab(this.props.permissions) &&
          this.performAdminAction(configType)}
      </React.Fragment>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({});

export const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminConsole);
